export type MedicalRecordRequestStatus = "draft" | "ready" | string;

export type MedicalRecordRequest = {
  id: string;
  pdfUrl: string | null;
  status: MedicalRecordRequestStatus;
  patientId: string;
  patientName?: string | null;
  patient_name?: string | null;
  createdAt: string;
  recipientName?: string | null;
  recipient_name?: string | null;
  recipientType?: string | null;
  recipient_type?: string | null;
  recipientExternalId?: string | null;
  recipient_external_id?: string | null;
  deliveryMethod?: string | null;
  delivery_method?: string | null;
  faxNumber?: string | null;
  fax_number?: string | null;
  emailAddress?: string | null;
  email_address?: string | null;
  hasSignatureImage?: boolean | null;
  recipientDetails?: MedicalRecordRecipientDetails | null;
};

export type MedicalRecordRecipientDetails = {
  institution?: RecipientEntity | null;
  provider?: RecipientEntity | null;
};

export type RecipientEntity = {
  id?: string;
  name?: string | null;
  recipientName?: string | null;
  type?: string | null;
  phone?: string | null;
  phoneNumber?: string | null;
  fax?: string | null;
  email?: string | null;
  address?: string | null;
  contact_details?: MedicalRecordContactDetail[] | null;
};

export type MedicalRecordContactDetail = {
  id?: string;
  phone?: string | null;
  fax?: string | null;
  email?: string | null;
  department?: string | null;
  is_primary?: boolean | null;
};

export type MedicalRecordRequestsResponse = {
  data: MedicalRecordRequest[];
  error: string | null;
};

export const statusOptions = [
  "pending",
  "ready_to_review",
  "ready_to_send",
  "lookup_in_progress",
  "lookup_failed",
  "no_fax_found",
  "fax_sending",
  "fax_sent",
  "fax_failed",
  "department_not_attempted",
  "department_contacted",
  "department_contact_attempted",
  "department_confirmed_receipt",
  "department_confirmed_processed",
  "department_rejected",
  "completed",
  "canceled",
];
